"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _reactVirtualized = require("react-virtualized");

var _material = require("@mui/material");

var _ui = require("@alycecom/ui");

var _services = require("@alycecom/services");

var _useTrackGiftingFlow = require("../../hooks/useTrackGiftingFlow");

var _GridCell = _interopRequireDefault(require("./GridCell"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var styles = {
  title: {
    fontSize: '1.5rem',
    lineHeight: '2rem',
    color: 'primary.main',
    mb: 1
  },
  subtitle: {
    fontSize: '0.75rem',
    lineHeight: '1.25rem',
    color: 'primary.main'
  }
};

var initialState = _services.partialBatchesAdapter.getInitialState({
  pagination: {}
});

var combineResponse = function combineResponse(state, response) {
  return _objectSpread(_objectSpread({}, _services.partialBatchesAdapter.upsertMany(state, response.data)), {}, {
    pagination: response.pagination
  });
};

var BatchesList = function BatchesList(_ref) {
  var _queryState$paginatio;

  var onBack = _ref.onBack,
      onItemClick = _ref.onItemClick;

  var _appApi$useDeletePros = _services.appApi.useDeleteProspectingBatchByIdMutation(),
      _appApi$useDeletePros2 = (0, _slicedToArray2.default)(_appApi$useDeletePros, 1),
      deleteBatchById = _appApi$useDeletePros2[0];

  var _useInfiniteQuery = (0, _services.useInfiniteQuery)(_services.appApi.endpoints.getProspectingPartialBatches, initialState, {
    combineResponse
  }),
      fetchNext = _useInfiniteQuery.fetchNext,
      queryState = _useInfiniteQuery.queryState,
      setQueryState = _useInfiniteQuery.setQueryState,
      isSuccess = _useInfiniteQuery.isSuccess;

  var paginationTotal = (_queryState$paginatio = queryState.pagination) === null || _queryState$paginatio === void 0 ? void 0 : _queryState$paginatio.total;
  var isCanLoadMore = typeof paginationTotal !== 'number' || paginationTotal > queryState.ids.length;
  var rowsCount = isCanLoadMore ? queryState.ids.length + 20 : queryState.ids.length;
  var measurerCache = (0, _react.useMemo)(function () {
    return new _reactVirtualized.CellMeasurerCache({
      minHeight: 112,
      fixedWidth: true
    });
  }, []);
  var handleLoadMore = (0, _react.useCallback)(function () {
    if (isCanLoadMore) {
      fetchNext(function (currentState) {
        return {
          isSent: false,
          pagination: {
            limit: 10,
            offset: currentState.ids.length
          }
        };
      }, {
        preferCacheValue: true
      });
    }

    return Promise.resolve();
  }, [fetchNext, isCanLoadMore]);

  var makeHandleBatchClick = function makeHandleBatchClick(batchId) {
    return function () {
      if (onItemClick && batchId) {
        onItemClick(batchId);
      }
    };
  };

  var makeHandleDeleteBatch = function makeHandleDeleteBatch(batchId) {
    return function () {
      if (batchId) {
        deleteBatchById({
          batchId
        });
        setQueryState(function (currentState) {
          return _objectSpread({}, _services.partialBatchesAdapter.removeOne(currentState, batchId));
        });
      }
    };
  };

  (0, _react.useEffect)(function () {
    if (isSuccess && paginationTotal === 0 && onBack) {
      onBack();
    }
  }, [onBack, isSuccess, paginationTotal]);
  var trackCampaignsListBatchesListBackButtonClicked = (0, _useTrackGiftingFlow.useCampaignsListBatchesListBackButtonClicked)();
  var handleBackButtonClick = (0, _react.useCallback)(function () {
    if (onBack) {
      trackCampaignsListBatchesListBackButtonClicked();
      onBack();
    }
  }, [onBack, trackCampaignsListBatchesListBackButtonClicked]);
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    py: 3,
    px: 1,
    height: 1,
    bgcolor: "additional.chambray05",
    display: "flex",
    flexDirection: "column"
  }, !!onBack && /*#__PURE__*/_react.default.createElement(_material.Box, {
    mb: 1
  }, /*#__PURE__*/_react.default.createElement(_ui.Button, {
    variant: "text",
    onClick: handleBackButtonClick,
    startIcon: /*#__PURE__*/_react.default.createElement(_ui.Icon, {
      icon: "arrow-left"
    })
  }, "Back")), /*#__PURE__*/_react.default.createElement(_material.Box, {
    flex: "0 0 auto",
    px: 2,
    pb: 3
  }, paginationTotal && /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: styles.title
  }, paginationTotal, " Batch", paginationTotal > 1 ? 'es' : '', " in progress"), /*#__PURE__*/_react.default.createElement(_material.Box, {
    sx: styles.subtitle
  }, "Resume sending bulk gifts in progress.")), /*#__PURE__*/_react.default.createElement(_material.Box, {
    flex: "1 1 auto"
  }, /*#__PURE__*/_react.default.createElement(_reactVirtualized.InfiniteLoader, {
    loadMoreRows: handleLoadMore,
    isRowLoaded: function isRowLoaded(_ref2) {
      var index = _ref2.index;
      return !!queryState.ids[index];
    },
    rowCount: rowsCount,
    minimumBatchSize: 10,
    threshold: 5
  }, function (_ref3) {
    var registerChild = _ref3.registerChild,
        onRowsRendered = _ref3.onRowsRendered;
    return /*#__PURE__*/_react.default.createElement(_reactVirtualized.AutoSizer, {
      style: {
        height: '100%'
      }
    }, function (_ref4) {
      var height = _ref4.height,
          width = _ref4.width;
      return /*#__PURE__*/_react.default.createElement(_reactVirtualized.Grid, {
        ref: registerChild,
        width: width,
        columnWidth: width,
        height: height,
        columnCount: 1,
        rowCount: rowsCount,
        rowHeight: measurerCache.rowHeight,
        deferredMeasurementCache: measurerCache,
        onSectionRendered: function onSectionRendered(_ref5) {
          var rowStartIndex = _ref5.rowStartIndex,
              rowStopIndex = _ref5.rowStopIndex;
          return onRowsRendered({
            startIndex: rowStartIndex,
            stopIndex: rowStopIndex
          });
        },
        cellRenderer: function cellRenderer(gridCellProps) {
          return /*#__PURE__*/_react.default.createElement(_GridCell.default, (0, _extends2.default)({}, gridCellProps, {
            cache: measurerCache,
            batch: queryState.entities[queryState.ids[gridCellProps.rowIndex]],
            onClick: makeHandleBatchClick(queryState.ids[gridCellProps.rowIndex]),
            onDelete: makeHandleDeleteBatch(queryState.ids[gridCellProps.rowIndex])
          }));
        }
      });
    });
  })));
};

var _default = BatchesList;
exports.default = _default;